<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div class="row">
            <div class="col">
              <Filters
                :filters="filters"
                :applying="applying"
                v-on:apply="apply()"
                :hideCompany="filterDisplay.hideCompany"
                :hideRegion="filterDisplay.hideRegion"
                :hideBranch="filterDisplay.hideBranch"
                :hideDevice="filterDisplay.hideDevice"
                :hideDate="filterDisplay.hideDate"
                :hidePromotionalInfo="true"
              ></Filters>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <b-form-group label-for="keyword" label="Keyword">
                <input
                  id="keyword"
                  type="text"
                  class="form-control"
                  v-model="filters.keyword"
                />
              </b-form-group>
            </div>
            <div class="col"></div>
            <div class="col"></div>
            <div class="col text-center"></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-button variant="success" v-on:click="goTo('/admin/users/add')"
            ><i class="fa fa-plus"></i> Add New User</b-button
          >
        </b-card>
        <div class="card">
          <div class="card-header">
            <div>
              <i class="fa fa-align-justify"></i> Users ({{
                pagination.total
              }})<span class="small float-right mt-1"
                ><i class="fa cui-star superAdminStar ml-2"></i> Super Admin
                <i class="fa cui-star ml-2"></i> Admin
                <i class="fa fa-thermometer-half ml-2"></i> Tester
                <i class="fa fa-wifi ml-2"></i> Customer</span
              >
            </div>
          </div>
          <div class="card-body">
            <div v-if="!tableReady" class="table-loading-container">
              <img
                src="/img/wifi-loading.gif"
                alt="loading"
                class="loading-table"
              />
            </div>
            <div v-if="tableReady">
              <div v-if="!items.length">
                <b-alert show variant="warning">
                  No Users
                </b-alert>
              </div>
              <table class="table table-striped" v-if="items.length">
                <thead>
                  <tr>
                    <th><a href="#" @click.prevent="sort('name')">Name</a></th>
                    <th>MAC Address</th>
                    <th>Branch</th>
                    <th>
                      <a href="#" @click.prevent="sort('dateAdded')"
                        >Date Created</a
                      >
                    </th>
                    <th style="width: 160px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item._id">
                    <td>
                      <i
                        :title="item.isSuperAdmin ? 'Super Admin' : 'Admin'"
                        class="cui-star mr-2"
                        v-if="item.isAdmin || item.isSuperAdmin"
                        :class="{ superAdminStar: item.isSuperAdmin }"
                      ></i>
                      <i
                        title="Holly-Fi User"
                        class="fa fa-wifi mr-2"
                        v-if="
                          !item.isAdmin && !item.isSuperAdmin && !item.isTester
                        "
                      ></i>
                      <i
                        title="Holly-Fi User"
                        class="fa fa-thermometer-half mr-2"
                        v-if="item.isTester"
                      ></i>
                      <router-link
                        :to="{ name: 'Update User', params: { id: item._id } }"
                        >{{ item.firstName }} {{ item.lastName }}</router-link
                      >
                    </td>
                    <td>{{ item.macAddress }}</td>
                    <td>
                      <div v-if="item.branch">{{ item.branch.name }}</div>
                    </td>
                    <td>{{ item.dateAdded | formatDate }}</td>
                    <td>
                      <button
                        class="btn btn-sm btn-danger mr-1"
                        @click="deleteItem(item)"
                        v-if="!item.isSuperAdmin"
                      >
                        <i class="fa fa-remove"></i> Delete
                      </button>
                      <router-link
                        class="btn btn-sm btn-primary"
                        :to="{ name: 'Answers', params: { userId: item._id } }"
                        >Answers</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style="float: left;">
                <div class="mb-2">
                  <b-form-select
                    style="width: 70px;"
                    id="Limit"
                    :options="limitsList"
                    required
                    v-model="pagination.limit"
                  >
                  </b-form-select>
                  <span> Users per page</span>
                </div>
                <nav>
                  <b-pagination
                    :total-rows="pagination.total"
                    :per-page="pagination.limit"
                    v-model="pagination.page"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </b-col> </b-row
    ><!--/.row-->
    <b-modal
      title="Confirm Delete"
      class="modal-danger"
      v-model="deleteModal"
      @ok="confirmDelete()"
      ok-variant="danger"
    >
      <div><b>Are you sure you want to delete this user?</b></div>
      <div>{{ selectedItem.firstName }} {{ selectedItem.lastName }}</div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import common from "./../../../mixins/common";
import filter from "./../../../mixins/filter";
import Filters from "@/views/common/Filters";

export default {
  name: "users",
  components: {
    Filters
  },
  data() {
    return {
      selectedItem: {},
      items: [],
      deleteModal: false,
      tableReady: false,
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
        sort: "dateAdded",
        sortDir: -1
      },
      limits: [10, 50, 100],
      filters: {
        allTime: false
      }
    };
  },
  mixins: [common, filter],
  computed: {
    limitsList: function() {
      return this.limits.map(limit => {
        return {
          text: limit,
          value: limit
        };
      });
    }
  },
  methods: {
    apply() {
      this.getItems();
    },
    getItems: function() {
      let scope = this;
      scope.tableReady = false;

      let search = {
        pagination: scope.pagination,
        where: {}
      };

      if (
        scope.filters.company &&
        scope.filters.region &&
        scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company,
          region: scope.filters.region,
          branch: scope.filters.branch
        };
      } else if (
        scope.filters.company &&
        scope.filters.region &&
        !scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company,
          region: scope.filters.region
        };
      } else if (
        scope.filters.company &&
        !scope.filters.region &&
        !scope.filters.branch
      ) {
        search.where = {
          company: scope.filters.company
        };
      }

      if (scope.filters.allTime) {
        search.fromDate = scope.$store.getters.allTime.fromDate;
        search.toDate = scope.$store.getters.allTime.toDate;
      } else {
        search.fromDate = scope.filters.fromDate;
        search.toDate = scope.filters.toDate;
      }
      search.keyword = scope.filters.keyword;

      scope.$store.dispatch("getUserReport", search).then(
        result => {
          scope.items = result.docs;
          scope.pagination.total = result.total;
          scope.tableReady = true;
        },
        error => {
          console.log(error);
          scope.applying = false;
        }
      );
    },
    deleteItem: function(selItem) {
      this.selectedItem = selItem;
      this.deleteModal = true;
    },
    confirmDelete: function() {
      this.deleteModal = false;
      let scope = this;
      axios
        .delete(process.env.VUE_APP_API + "/user/" + scope.selectedItem._id, {
          headers: {
            Authorization: "JWT " + scope.$localStorage.get("holly-fi-token")
          }
        })
        .then(function(response) {
          scope.getItems();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    sort(sortOrder) {
      this.pagination.sort = sortOrder;
      this.getItems();
    }
  },
  created() {
    this.filterDisplay.hideRegion = false;
    this.filterDisplay.hideBranch = false;
    this.filterDisplay.hideDate = false;
    this.setupFilter();
    setTimeout(() => {
      this.getItems();
    }, 1000);
  },
  watch: {
    "pagination.page": function(val) {
      this.getItems();
    },
    "pagination.limit": function(val) {
      this.getItems();
    }
  }
};
</script>
